import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CardReader = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
        <path d="M5.322.939c0-.184.149-.334.333-.334h4.687c.184 0 .333.15.333.334v2.897h.45a.333.333 0 0 1 .334.333v9.02A3.467 3.467 0 0 1 8 16.647a3.467 3.467 0 0 1-3.458-3.458v-9.02c0-.184.15-.333.333-.333h.446V.94Zm.666 2.897h4.02V1.272h-4.02v2.564Zm1.23-1.912c.183 0 .333.149.333.333v.632a.333.333 0 0 1-.667 0v-.632c0-.184.15-.333.333-.333Zm1.562 0c.184 0 .333.149.333.333v.632a.333.333 0 1 1-.667 0v-.632c0-.184.15-.333.334-.333ZM5.21 4.503v8.686A2.8 2.8 0 0 0 8 15.98a2.8 2.8 0 0 0 2.792-2.791V4.503H5.21Z" />
        <path d="M6.105 7.187c0-.184.15-.333.334-.333h3.125c.184 0 .333.149.333.333v6.002c0 1.04-.855 1.896-1.896 1.896a1.905 1.905 0 0 1-1.896-1.896V7.187Zm.667.333v5.669c0 .672.557 1.23 1.23 1.23.672 0 1.229-.558 1.229-1.23V7.52H6.772ZM1.889 7.183c0-.184.149-.333.333-.333h2.499a.333.333 0 1 1 0 .666H2.555v.582l.32.213a.333.333 0 0 1 .149.278v1.878a.333.333 0 0 1-.149.277l-.32.213v.582h2.166a.333.333 0 1 1 0 .667H2.222a.333.333 0 0 1-.333-.334V10.78c0-.111.055-.216.148-.277l.32-.214V8.767l-.32-.213a.333.333 0 0 1-.148-.278V7.183Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 .625h16v15.999H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

CardReader.category = 'product-category';

CardReader.displayName = 'CardReader';
